import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import language from '../../../js/stores/language.js';
import carFeatures from '../../../js/stores/car-feature.js';

//Create custom component to export
//const CarFeatures = (props, { $, $f7, $h, $update, $onMounted, $emit }) => {
function framework7Component(props, _ref) {
  var $ = _ref.$,
    $f7 = _ref.$f7,
    $h = _ref.$h,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted,
    $emit = _ref.$emit;
  var locale = language.getters.Item.value;
  var list = [];
  var data = props.list;
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var i, key, object;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          i = 0;
          for (key in data) {
            object = {
              "carFeatureDetailId": data[i].featureDetailId,
              "friendlyName": data[i].name,
              "value": data[i].value,
              "type": data[i].type,
              "isUsed": data[i].isUsed,
              "iconImage": data[i].iconImage,
              "iconType": data[i].iconType
            };
            i++;
            list.push(object);
          }
          $update();
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  var saveCarFeatureCheck = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
      var carFeatureDetailId, verifCheck, fieldValue, verifValue, _data, result, _t;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            carFeatureDetailId = e.target.dataset.carFeatureDetailId;
            verifCheck = $("#car-feature-detail-id-".concat(carFeatureDetailId)).prop('checked') ? 1 : 0;
            fieldValue = $("#verif-input-".concat(carFeatureDetailId)).val();
            verifValue = fieldValue;
            if (fieldValue === 'on') {
              verifValue = $("#verif-input-".concat(carFeatureDetailId)).prop('checked') ? 1 : 0;
            }
            _data = {
              CarFeatureDetailId: carFeatureDetailId,
              CarFeatureDetailIsUsed: verifCheck,
              CarFeatureDetailValue: verifValue
            };
            _context2.next = 1;
            return carFeatures.dispatch('updateSingleFeature', _data);
          case 1:
            result = _context2.sent;
            if (!(result.status !== undefined && result.status !== 200 && result.status !== 204)) {
              _context2.next = 2;
              break;
            }
            $f7.toast.show({
              text: result.data.messages.error
            });
            return _context2.abrupt("return");
          case 2:
            console.log("Feature updated");
            _context2.next = 4;
            break;
          case 3:
            _context2.prev = 3;
            _t = _context2["catch"](0);
            console.error(_t);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 3]]);
    }));
    return function saveCarFeatureCheck(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var onPopUpClose = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 1;
            return $f7.emit('updateFeatures');
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function onPopUpClose() {
      return _ref4.apply(this, arguments);
    };
  }();
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="popup car-features-popup" @popup:close=${onPopUpClose}>
  <div class="view view-init">
    <div class="page page-with-navbar-large">
      <div class="navbar navbar-large navbar-transparent">
        <div class="navbar-bg"></div>
        <div class="navbar-inner">
          <div class="title">${props.titleShort}</div>
          <div class="right"><a class="link popup-close"><i class="icon material-symbols-outlined color-red">cancel</i></a></div>
          <div class="title-large">
            <div class="title-large-text">${props.titleDialog}</div>
          </div>
        </div>
      </div>
      <div class="page-content">
        <div class="block">
          <form id="car-features-form">
            <div class="data-table card">
              <table>
                <thead>
                  <tr>
                    <th class="checkbox-cell">${locale.translate('car.features.isUsed')}</th>
                    <th class="label-cell">${locale.translate('car.features.name')}</th>
                    <th class="label-cell">${locale.translate('car.features.value')}</th>
                    <th class="label-cell">Icon</th>
                  </tr>
                </thead>
                <tbody>
                ${list.map((item) => $h`
                  <tr>
                    <td class="checkbox-cell">
                      <label class="checkbox">
                        <input id="car-feature-detail-id-${item.carFeatureDetailId}" checked="${item.isUsed > 0 && $h`checked`}" type="checkbox" 
                        data-car-feature-detail-id="${item.carFeatureDetailId}" @click="${saveCarFeatureCheck}" />
                        <i class="icon-checkbox"></i>
                      </label>
                    </td>
                    <td class="">${item.friendlyName}</td>
                    ${(item.type == 1 || item.type == 2) && $h`
                    <td class="input-cell">
                      <div class="input">
                        <input id="verif-input-${item.carFeatureDetailId}" type="${item.type == 1 ? $h`number`:$h`text`}" autocomplete="off" value="${item.value}" 
                        data-car-feature-detail-id="${item.carFeatureDetailId}" @blur="${saveCarFeatureCheck}" />
                      </div>
                    </td>
                    `}
                    ${item.type == 0 && $h`
                    <td class="input-cell">
                      <label class="toggle">
                        <input id="verif-input-${item.carFeatureDetailId}" type="checkbox" checked="${item.value > 0 && $h`checked`}" 
                        data-car-feature-detail-id="${item.carFeatureDetailId}" @click="${saveCarFeatureCheck}"/>
                        <span class="toggle-icon"></span>
                      </label>
                    </td>
                    `}
                    ${(item.iconType == 1 || item.iconType == 2) && $h`
                    <td class="label-cell">
                      <div class="chip-media bg-color-blue">
                      ${item.iconType == 1 && $h`
                        <i class="icon material-symbols-outlined">${item.iconImage}</i>
                      `}
                      ${item.iconType == 2 && $h`
                        <img class="" width="50px" height="50px" src="/static/icons/features/${item.iconImage}"/> 
                      `}
                      </div>
                    </td>
                    `}
                  </tr>
                `)}
                </tbody>
              </table>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
`
    }
    ;
}
framework7Component.id = '29c3f6e31e';
export default framework7Component;